<div class="danske-spil-iframe-wrapper">
    <iframe [attr.src]="url | trustAsResourceUrl"></iframe>
</div>
